import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Spinner,
} from "reactstrap";
import { Modal, Select, Table, notification } from "antd";
import moment from "moment";
import { Link, useParams } from "react-router-dom";
import {
  CallFindAdminByVendorId,
  CallFindAllUsersByParams,
  CallAddSchoolAdmin,
  CallDeleteSchoolAdmin,

  CallUpdateStatus,
} from "services/apiAction";
import JsonToXlsxDownload from "../../utils/JsonToXlsxDownload";

const SchoolList = () => {
  const [api, contextHolder] = notification.useNotification();
  const ID = useParams();
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [schoolIds, setSchoolIds] = useState([]);
  const [data, setData] = useState([]);
  const [schoolData, setSchoolData] = useState([]);
  const [modal, setModal] = useState(false);
  const [modalType, setModalType] = useState(false);
  const [totalCounts, setTotalCounts] = useState(0);
  const [SchoolCount, setSchoolCount] = useState(0);
  const [StudentCount, setStudentCount] = useState(0);

  const [pageData, setPageData] = useState({
    pageNo: 1,
    limit: 20,
    vendorId: ID?.id,
  });

  useEffect(() => {
    GetSchoolData();
    GetData();
  }, [pageData.limit, pageData.pageNo]);

  const GetData = async () => {
    try {
      setLoading(true);
      const res = await CallFindAdminByVendorId(pageData);
      if (res?.data?.message === "Success") {
        const newData = res?.data?.admins?.map((item, index) => ({
          ...item,
          key: index,
        }));
        setData(newData);
        setTotalCounts(res?.data?.totalCount || 0);
        setSchoolCount(res?.data?.schoolCount || 0);
        setStudentCount(res?.data?.studentCount || 0);
      }
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };

  const GetSchoolData = async () => {
    try {
      setLoading(true);
      const res = await CallFindAllUsersByParams("role=school");
      if (res?.data?.message === "Success") {
        const options = res?.data?.admin?.map((item) => ({
          label: `${item?.firstName || ""} ${item?.lastName || ""}`,
          value: item?._id,
        }));
        setSchoolData(options);
      }
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };

  const handleEdit = async (id, status, name) => {
    try {
      const formdata = new FormData();
      formdata.append(name === "status" ? "status" : "isChecked", !status);
      const res = await CallUpdateStatus(id, formdata);
      if (res?.data?.message === "Success") {
        api.success({ message: res.data.message, duration: 2 });
        GetData();
      }
    } catch (error) {
      console.error(error);
    }
  };

  const filteredData = data.filter((item) => {
    const term = search.toLowerCase();
    return (
      item?.email?.toLowerCase()?.includes(term) ||
      item?.mobile?.toLowerCase()?.includes(term)
    );
  });

  const columns = [
    {
      title: "Sr No.",
      render: (id, data, idx) =>
        idx + 1 + pageData.limit * (pageData.pageNo - 1),
    },
    {
      title: "Name",
      render: (id, item) => `${item.firstName} ${item.lastName}`,
    },
    { title: "Mobile", dataIndex: "mobile" },
    { title: "Email", dataIndex: "email" },
    {
      title: "Created Date",
      dataIndex: "created_at",
      render: (date) => moment(date).format("ll"),
    },
    {
      title: "Status",
      render: (id, item) => (
        <Label className="custom-toggle custom-toggle-warning">
          <Input
            type="checkbox"
            onClick={() => handleEdit(item?._id, item?.status, "status")}
            defaultChecked={item?.status}
          />
          <span className="custom-toggle-slider rounded-circle" />
        </Label>
      ),
    },
    {
      title: "Checked",
      render: (id, item) => (
        <Label className="custom-toggle custom-toggle-warning">
          <Input
            type="checkbox"
            onClick={() => handleEdit(item?._id, item?.isChecked, "checked")}
            defaultChecked={item?.isChecked}
          />
          <span className="custom-toggle-slider rounded-circle" />
        </Label>
      ),
    },
    {
      title: "Action",
      render: (id, item) => (
        <>
          <Button
            tag={Link}
            to={`/admin/vendor/school-listing/${item._id}/adminListing`}
            className="background-primary"
            state={{ schoolId: item?._id, vendorId: ID?.id, role: "vendor" }}
            size="sm"
          >
            <i className="fas fa-eye text-primary" />
          </Button>
          <Button
            size="sm"
            onClick={() => {
              setSchoolIds(item?._id);
              setModalType("remove");
              setModal(true);
            }}
          >
            <i className="far fa-trash-alt text-red" />
          </Button>
        </>
      ),
    },
  ];

  const handleAddSchool = async () => {
    try {
      const payload = { schoolAdminIds: schoolIds, adminId: ID?.id };
      const res = await CallAddSchoolAdmin(payload);
      if (res?.data) {
        GetData();
        api.success({ message: "School Assigned", duration: 2 });
        setModal(false);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleDeleteSchool = async () => {
    try {
      setLoading(true);
      const payload = { schoolAdminIds: schoolIds, adminId: ID?.id };
      const res = await CallDeleteSchoolAdmin(payload);
      if (res?.data) {
        GetData();
        api.success({ message: "School Removed", duration: 2 });
        setModal(false);
      }
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };

  return (
    <Container className="my-5" fluid>
      {contextHolder}
      <Row>
        <div className="col">
          <Card className="shadow">
            <CardHeader className="border-0 pb-0 d-flex justify-content-between flex-wrap">
              <div className="d-flex align-items-center">
              <h3 className="mb-0">School List</h3>
              <Card className="p-1 mb-0 ml-3" style={{ backgroundColor: "#f7fafc" }}>
                <span id="TotalSubusers" className="mr-3 font-weight-bold">
                  Total Schools: <Button color="primary" className="ml-3 mr--3" size="sm">{SchoolCount}</Button>
                </span>
              </Card>
              <Card className="p-1 mb-0 ml-3" style={{ backgroundColor: "#f7fafc" }}>
                <span id="TotalSubusers" className="mr-3 font-weight-bold">
                  Total Students: <Button color="primary" className="ml-3 mr--3" size="sm">{StudentCount}</Button>
                </span>
              </Card>
              </div>
              <div className="d-flex align-items-center mt-2 mt-md-0">
                <Button
                  color="primary"
                  size="sm"
                  onClick={() => {
                    setModalType("add");
                    setModal(true);
                  }}
                  className="mr-3 p-2"
                >
                  Assign School
                </Button>
                <JsonToXlsxDownload jsonData={data} fileName="SchoolList" />
                <div className="search-container d-flex ml-3">
                  <Input
                    placeholder="Search"
                    className="rounded-pill"
                    value={search}
                    type="search"
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </div>
              </div>
            </CardHeader>
            <CardBody>
              <Table
                dataSource={filteredData}
                columns={columns}
                loading={loading}
                scroll={{ x: "max-content" }}
                pagination={{
                  current: pageData.pageNo,
                  pageSize: pageData.limit,
                  total: totalCounts,
                  showSizeChanger: true,
                  showQuickJumper: true,
                  onChange: (page, pageSize) =>
                    setPageData({ ...pageData, pageNo: page, limit: pageSize }),
                }}
              />
            </CardBody>
          </Card>
        </div>
      </Row>
      <Modal
        title={modalType === "add" ? "Assign School" : "Remove School"}
        open={modal}
        onCancel={() => setModal(false)}
        footer={null}
        width={modalType === "add" ? 600 : 400}
      >
        {modalType === "add" ? (
          <Form className="mt-3">
            <Row>
              <Col lg="12">
                <FormGroup>
                  <Label>Select School(s)</Label>
                  <Select
                    mode="multiple"
                    allowClear
                    style={{ width: "100%" }}
                    placeholder="Select schools"
                    onChange={(val) => setSchoolIds(val)}
                    options={schoolData}
                  />
                </FormGroup>
              </Col>
              <Col lg="12">
                <Button
                  color="dark"
                  className="w-100"
                  onClick={handleAddSchool}
                  disabled={loading}
                >
                  {loading && <Spinner size="sm" className="mr-2" />} Submit
                </Button>
              </Col>
            </Row>
          </Form>
        ) : (
          <div className="mt-3">
            <h5>
              {loading ? (
                <Spinner size="sm" className="mr-2" />
              ) : (
                <i className="fas fa-exclamation-circle text-warning mr-2" />
              )}
              Are you sure you want to remove this school?
            </h5>
            <div className="mt-4 d-flex justify-content-end">
              <Button
                color="danger"
                size="sm"
                onClick={handleDeleteSchool}
                disabled={loading}
              >
                Yes
              </Button>
              <Button
                outline
                color="secondary"
                size="sm"
                onClick={() => setModal(false)}
                className="ml-2"
              >
                No
              </Button>
            </div>
          </div>
        )}
      </Modal>
    </Container>
  );
};

export default SchoolList;